import { TActivity } from '@/domain/Activities.domain';

export const mapTripsByCategory = (activities: TActivity[], categories?: string[]) => {
    if (!categories) {
        return activities;
    }

    return activities.filter(({ id }) => categories.includes(id));
};
